const tipoRegimeTributarioEmpresaList = [
    {
        id: 'M',
        descricao: 'MEI - Microempreendedor Individual',
        ordem: 10,
    },
    {
        id: 'S',
        descricao: 'Simples Nacional',
        ordem: 20,
    },
    {
        id: 'P',
        descricao: 'Lucro Presumido',
        ordem: 30,
    },
    {
        id: 'R',
        descricao: 'Lucro Real',
        ordem: 40,
    },
]

export default tipoRegimeTributarioEmpresaList
